<template>
  <div>
    <a-table bordered
             :loading="loading"
             :columns="columns"
             :data-source="adminuserList"
             :pagination="pagination"
             @change="handleTableChange"
    >
<!--      <template slot="headUrl" slot-scope="headUrl">-->
<!--        <a-avatar shape="square" size="small" icon="adminuser" :src="headUrl"/>-->
<!--      </template>-->
      <template slot="headUrl" slot-scope="headUrl">
        <a-avatar shape="square" size="small" icon="user" :src="headUrl"/>
      </template>
      <template slot="forze" slot-scope="forze, record">
        <a-tag v-if="forze" color="red">已冻结</a-tag>
        <a-tag v-else color="green">正常</a-tag>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" v-if="hasPerm('/deviceuser/addDeviceuser')" class="margin-right-30" @click="openDevice(record)">授权设备</a>
        <a href="javascript:;" v-if="hasPerm('/admin-user/assign')" class="margin-right-30" @click="openRole(record)">授权角色</a>
        <a href="javascript:;" v-if="hasPerm('/admin-user/save')" class="margin-right-30" @click="lookAdminuserInfo(record)">修改</a>
        <a href="javascript:;" v-if="record.name === 'admin' && hasPerm('/admin-user/freeze')" class="margin-right-30 action-disabled" style="color: #ff9800;">冻结</a>
        <a href="javascript:;" v-else-if="!record.forze && hasPerm('/admin-user/freeze')" class="margin-right-30" style="color: #ff9800;" @click="freezeUser(record)">冻结</a>
        <a href="javascript:;" v-else-if="record.forze && hasPerm('/admin-user/freeze')" class="margin-right-30" style="color: #4caf50;" @click="unfreezeUser(record)">解冻</a>
        <a href="javascript:;" v-if="hasPerm('/admin-user/freeze')" class="margin-right-30" style="color: #1890ff;" @click="viewFreezeHistory(record)">冻结历史</a>
        <a href="javascript:;" v-if="hasPerm('/admin-user/')" style="color: #E84D11;" @click="delAdminuser(record)">删除</a>
      </template>
    </a-table>
    <!-- 删除弹窗 -->
    <a-modal v-model="DELvisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="DelSpinning">
        <div class="delAdminuser">
          <div class="DelTitle">删除</div>
          <img src="~@/assets/image/common/DelHint.png" class="delIcon" alt=""/>
          <div class="delHint">是否删除{{ DELadminuserName }}</div>
          <div class="btn-wrap">
            <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
            <a-button class="confirm" @click="confirm">确定</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>
    <!-- 查看详情 -->
    <a-modal v-model="adminuserinfoVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="infoSpinning">
        <div class="adminuserInfo-title">后台用户详情</div>
        <a-form-model ref="adminuserInfo" v-bind="layout" :model="adminuserInfo" :rules="adminuserInfoFormRules">
          <a-form-model-item has-feedback label="用户账号" prop="name">
            <a-input v-model="adminuserInfo.name" type="text" :maxLength="150" disabled  autocomplete="off" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="用户昵称" prop="nickname">
            <a-input v-model="adminuserInfo.nickname" type="text" :maxLength="150" :disabled="!btnShow" autocomplete="off" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="手机号" prop="tel">
            <a-input v-model="adminuserInfo.tel" type="text" :maxLength="11" :disabled="!btnShow" autocomplete="off" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="用户密码" prop="password">
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>密码为空则表示不修改密码</span>
              </template>
              <a-input-password v-model="adminuserInfo.password" placeholder="请输入密码" type="password" :maxLength="150"
                                :disabled="!btnShow"  autocomplete="new-password">
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
              </a-input-password>
            </a-tooltip>
          </a-form-model-item>

          <a-form-model-item has-feedback label="SSO-UID" prop="uid">
            <a-input v-model="adminuserInfo.uid" type="text" :maxLength="150" :disabled="!btnShow" autocomplete="off"/>
          </a-form-model-item>

          <a-form-model-item has-feedback label="对应单位" prop="company">
            <a-input v-model="adminuserInfo.company" type="text" :maxLength="200" :disabled="!btnShow" autocomplete="off"/>
          </a-form-model-item>

        </a-form-model>

        <div class="adminuserInfo-btn-wrap">
          <a-button class="btn cancel margin-right-30" @click="AdminuserInfoCancel">取消</a-button>
          <a-button class="btn btn-active" v-if="!btnShow && hasPerm('/admin-user/save')" @click="AdminuserInfoEdit">修改</a-button>
          <a-popconfirm
            title="确定提交修改吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="confirmEdit('adminuserInfo')"
          >
            <a-button class="btn btn-active" v-if="btnShow">提交</a-button>
          </a-popconfirm>
        </div>
      </a-spin>
    </a-modal>

    <!-- 关联菜单 -->
    <a-modal v-model="roleVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="roleSpinning">
        <div class="userInfo-title">授权角色</div>
        后台用户账号：
        <a-tag color="blue">
          {{adminuserByRole.name}}
        </a-tag>

        <a-divider orientation="left">角色</a-divider>

        <a-checkbox-group v-model="checkedKeys" @change="onChange" style="width: 100%;min-width:200px;min-height: 50px;display: block;">
          <a-row>
            <a-col v-for="(item,index) in roleList" :key="item.id" :span="8" style="margin-bottom: 8px;">
              <a-checkbox :value="item.id">
                <a-tooltip :title="item.name" placement="top">
                  <span style="display:inline-block;max-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle;">{{item.name}}</span>
                </a-tooltip>
              </a-checkbox>
            </a-col>
          </a-row>
<!--          <a-checkbox v-for="(item,index) in roleList" :key="item.id"  :value="item.id">-->
<!--            {{item.name}}-->
<!--          </a-checkbox>-->
        </a-checkbox-group>
        <div class="userInfo-btn-wrap">
          <a-button class="btn margin-right-30" type="danger" @click="roleClear">全部清空</a-button>
          <a-button class="btn margin-right-30" type="primary" @click="roleCheckAll">全部选中</a-button>
          <a-button class="btn cancel margin-right-30" @click="roleCancel">取消</a-button>
          <a-popconfirm
            title="确定提交授权吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="addPower"
          >
            <a-button class="btn btn-active">授权</a-button>
          </a-popconfirm>

        </div>
      </a-spin>
    </a-modal>

    <!-- 冻结历史弹窗 -->
    <a-modal v-model="freezeHistoryVisible"
             title="冻结历史"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
             width="800px"
    >
      <a-spin :spinning="freezeHistoryLoading">
        <div class="freeze-history-info">
          用户账号：<a-tag color="blue">{{ currentUser.name }}</a-tag>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户昵称：<a-tag color="blue">{{ currentUser.nickname }}</a-tag>
        </div>
        <a-table
          bordered
          :columns="freezeHistoryColumns"
          :data-source="freezeHistoryList"
          :pagination="false"
          :scroll="{ y: 400 }"
        >
          <template slot="freezeType" slot-scope="freezeType">
            <a-tag v-if="freezeType === 1" color="red">冻结</a-tag>
            <a-tag v-else-if="freezeType === 2" color="green">解冻</a-tag>
            <a-tag v-else color="gray">未知</a-tag>
          </template>
          <template slot="freezeTime" slot-scope="freezeTime">
            {{ freezeTime | formatDate }}
          </template>
        </a-table>
        <div class="freeze-history-btn-wrap">
          <a-button class="btn" @click="closeFreezeHistory">关闭</a-button>
        </div>
      </a-spin>
    </a-modal>

    <!-- 关联设备 -->
    <a-modal v-model="deviceuserVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="deviceuserSpinning">
        <div class="userInfo-title">关联设备</div>
        当前用户姓名：
        <a-tag color="blue">
          {{user.nickname}}
        </a-tag>
        账号：
        <a-tag color="blue">
          {{user.name}}
        </a-tag>
        <!--        <span style="float: right;color: orange;">-->
        <!--          提示：可以重复授权，已做去重处理-->
        <!--        </span>-->
        <search @onSearch="onDeviceSearch" placeholder="请输入设备编码或IMEI搜索" style="margin:10px 0;" />
        <a-table bordered
                 :loading="deviceLoading"
                 :columns="deviceColumns"
                 :data-source="deviceList"
                 :pagination="devicePagination"
                 :row-selection="rowSelection"
                 @change="deviceHandleTableChange"
        >
        </a-table>

        <div class="userInfo-btn-wrap">

          <a-popconfirm
              title="确定全部解除吗？"
              ok-text="提交"
              cancel-text="取消"
              @confirm="unAllAuthorize"
          >
            <a-button class="btn margin-right-30" type="danger" >全部解除</a-button>
          </a-popconfirm>

          <a-popconfirm
              title="确定全部授权吗？"
              ok-text="提交"
              cancel-text="取消"
              @confirm="allAuthorize"
          >
            <a-button class="btn margin-right-30" type="primary">全部授权</a-button>
          </a-popconfirm>

          <a-button class="btn cancel margin-right-30" @click="deviceCancel">取消</a-button>
          <a-popconfirm
            title="确定提交授权吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="addDevice"
          >
            <a-button class="btn btn-active">授权</a-button>
          </a-popconfirm>

        </div>
      </a-spin>
    </a-modal>



  </div>
</template>

<script>
import {RoleAll} from "api/role";
import {AdminuserList, DelAdminuser, AdminuserInfo, upDataAdminuserInfo,saveAdminuserRoles,getAdminuserRoles, freezeUser, unfreezeUser, getFreezeRecords} from "api/adminuser";
import search from "@/components/content/search/Search";
import {hasPermission} from 'utils/hasPermission'
import {DeviceListBYUserId} from "api/device";
import {addDevice, allAuthorize, unAllAuthorize} from "api/deviceuser";

const allColumns = [
  {key: 'name', title: "账号", align: "center", dataIndex: 'name'},
  {key: 'nickname', title: "昵称", align: "center", dataIndex: 'nickname'},
  {key: 'company', title: "对应单位", align: "center", dataIndex: 'company'},
  {key: 'userName', title: "微信名称", align: "center", dataIndex: 'userName', perm: '/admin-user/column/userName'},
  {key: 'headUrl', title: '微信头像', align: "center", dataIndex: 'headUrl', scopedSlots: { customRender: 'headUrl' }, perm: '/admin-user/column/headUrl'},
  {key: 'tel', title: "手机号", align: "center", dataIndex: 'tel'},
  {key: 'forze', title: "状态", align: "center", dataIndex: 'forze', width: 100, scopedSlots: { customRender: 'forze' }},
  {key: 'registerTime', title: "最后登录时间", align: "center", dataIndex: 'registerTime'},
  {key: 'operation', title: '操作', align: "center", width: 440, dataIndex: 'operation', scopedSlots: {customRender: 'operation'}}
];

function getColumns() {
  return allColumns.filter(col => !col.perm || hasPermission(col.perm));
}
const deviceColumns = [
  {title: "设备id",width: '20%', align: "center", dataIndex: 'objectid'},
  {title: "设备编码", align: "center", dataIndex: 'vptNum'},
  {title: "IMEI", align: "center", dataIndex: 'name'},
];

const freezeHistoryColumns = [
  {title: "用户ID", align: "center", dataIndex: 'userId', width: 80},
  {title: "用户名", align: "center", dataIndex: 'userName', width: 120},
  {title: "操作类型", align: "center", dataIndex: 'freezeType', width: 100, scopedSlots: { customRender: 'freezeType' }},
  {title: "操作时间", align: "center", dataIndex: 'freezeTime', width: 180, scopedSlots: { customRender: 'freezeTime' }},
  {title: "操作人", align: "center", dataIndex: 'freezeBy', width: 120}
];

export default {
  name: 'AdminuserTable',
  components: {
    search
  },
  data() {
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户账号不能为空'));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      //修改时，密码为空则表示不修改
      if (value === '') {
        callback();
      } else if (value.length < 6) {
        callback(new Error('密码长度需6位及以上'));
      } else {
        callback();
      }
    };
    return {
      columns: getColumns(),
      pagination: {
        defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },

      layout: {
        labelCol: {span: 4},
        wrapperCol: {span: 20},
      },

      loading: false,
      DelSpinning: false,
      infoSpinning: false,

      pageIndex: 0,
      pageSize: 10,
      adminuserName: "",

      adminuserList: [],

      DELvisible: false,
      DELadminuserName: "",
      DELadminuserId: Number,

      adminuserinfoVisible: false,
      adminuserInfo: {
        id: "",
        name: "",
        nickname: "",
        password: "",
      },
      adminuserInfoFormRules: {
        name: [{validator: validateNickname, trigger: 'change'}],
        password: [{validator: validatePassword, trigger: 'change'}],
      },
      btnShow: false,

      //授权角色
      roleList: [],
      //已选中的
      checkedKeys: [],
      roleVisible: false,
      roleSpinning: false,
      adminuserByRole: {},

      //授权设备
      deviceuserVisible: false,
      deviceuserSpinning: false,
      deviceColumns,
      devicePagination: {
        defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.devicePagination.total} 条`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },
      deviceLoading: false,
      deviceList: [],
      devicePageIndex: 0,
      devicePageSize: 10,
      deviceName: "",
      user:"",
      //授权 选中参数
      selectedRowKeys:[],
      //授权 选中设备id
      objectids:[],
      //授权 关联表中的id
      selectedRowDUIds:[],

      // 冻结历史
      freezeHistoryVisible: false,
      freezeHistoryLoading: false,
      freezeHistoryList: [],
      freezeHistoryColumns,
      currentUser: {},

    };
  },
  computed: {
    rowSelection() {
      const {selectedRowKeys} = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.selectedRowKeys = selectedRowKeys;
          this.objectids = selectedRows.map((item) => {
            return item.objectid
          })
        },
      };
    },
  },
  mounted() {
    this.getAdminuserListData(this.pageIndex, this.pageSize, this.adminuserName)
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    /**
     * 菜单授权
     *
     */
    getRoleListData() {
      RoleAll()
        .then(res => {
          if (res.data.length > 0) {
            this.roleList = res.data;
          } else {
            this.roleList = []
            this.$message.error('没有查询到结果！');
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    getAdminuserRoles(adminuserId) {
      getAdminuserRoles(adminuserId)
        .then(res => {
          if (res.data.roleIds.length > 0) {
            this.checkedKeys = res.data.roleIds.map(item=>{return item+''})
          } else {
            console.log('该用户没有角色授权数据！');
          }
        })
        .catch(err => {
          console.log('获取用户角色数据出错！');
          console.log(err);
        })
    },
    onChange(checkedValues) {
      console.log('checked = ', checkedValues);
      console.log('checkedKeys = ', this.checkedKeys);
    },
    openRole(record) {
      console.log('openRole(record)', record)
      this.roleVisible = true;
      this.adminuserByRole = record;
      this.roleList = []
      this.checkedKeys = []
      this.getRoleListData()
      this.getAdminuserRoles(record.id)
    },
    roleCancel() {
      this.roleVisible = false;
      this.roleList = []
      this.checkedKeys = []
    },
    roleClear() {
      this.checkedKeys = []
    },
    roleCheckAll() {
      let ids = this.roleList.map(item => {
        return item.id
      })
      this.checkedKeys = ids
    },
    addPower() {
      saveAdminuserRoles(this.adminuserByRole.id, this.checkedKeys)
        .then(res => {
          this.$message.success('授权成功！');
          this.roleCancel()
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err.message);
        })
    },

    // 授权设备
    // 表格页面跳转
    deviceHandleTableChange(pagination, filters, sorter) {
      const pager = { ...this.devicePagination };
      console.log("pagination------------",pagination)
      pager.current = pagination.current;
      this.devicePagination = pager;
      this.devicePageIndex = pagination.current
      this.objectids = []
      this.selectedRowKeys = []
      this.selectedRowDUIds = []
      this.getDeviceListData(this.devicePageIndex, this.devicePageSize, this.deviceName)
    },
    getDeviceListData(pageIndex, pageSize, deviceName) {
      console.log("getDeviceListData==========",pageIndex, pageSize, deviceName)
      this.devicePagination.current = pageIndex;
      this.deviceLoading = true;
      DeviceListBYUserId(pageIndex, pageSize, deviceName, this.user.id)
        .then(res => {
          console.log(res.data);
          if(res.data.rows.length > 0) {
            this.devicePagination.total = res.data.total;
            this.deviceList = res.data.rows;
            this.deviceLoading = false;
            let selectedRowKeys = []
            let objectids = []
            let selectedRowDUIds = []
            this.deviceList.forEach((item,index)=>{
              if (item.isAuthorize != null && item.isAuthorize != 'null'){
                selectedRowKeys.push(index)
                objectids.push(item.objectid)
                selectedRowDUIds.push(item.isAuthorize)
              }
            })
            this.selectedRowKeys = selectedRowKeys
            this.objectids = objectids
            this.selectedRowDUIds = selectedRowDUIds
            console.log('this.selectedRowKeys:', this.selectedRowKeys, 'this.objectids: ', this.objectids, 'this.selectedRowDUIds: ', this.selectedRowDUIds);
          } else {
            this.deviceLoading = false;
            this.devicePagination.total = 0;
            this.deviceList = []
            this.$message.error('没有查询到结果，请重试！');

          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        })
    },
    addDevice() {
      const vm = this;
      this.deviceuserSpinning = true
      addDevice(this.objectids,this.user.id,this.selectedRowDUIds)
        .then(res => {
          console.log(res);
          this.deviceuserSpinning = false
          if(res.code != "0") {
            this.$message.error(res.message);
          } else {
            this.$message.success('设备关联成功！');
            // this.selectedRowKeys = []
          }
        })
        .catch(err => {
          vm.deviceuserSpinning = false
          console.log(err);
          this.$message.error(err.message);
        })
    },
    //全部授权
    allAuthorize(){
      const vm = this;
      this.deviceuserSpinning = true
      allAuthorize(this.user.id)
          .then(res => {
            console.log(res);
            this.deviceuserSpinning = false
            if(res.code != "0") {
              this.$message.error(res.message);
            } else {
              this.$message.success('全部授权成功！');
              this.getDeviceListData(this.devicePageIndex, this.devicePageSize, this.deviceName)
            }
          })
          .catch(err => {
            vm.deviceuserSpinning = false
            console.log(err);
            this.$message.error(err.message);
          })
    },
    //全部解除
    unAllAuthorize(){
      const vm = this;
      this.deviceuserSpinning = true
      unAllAuthorize(this.user.id)
          .then(res => {
            console.log(res);
            this.deviceuserSpinning = false
            if(res.code != "0") {
              this.$message.error(res.message);
            } else {
              this.$message.success('全部解除成功！');
              this.getDeviceListData(this.devicePageIndex, this.devicePageSize, this.deviceName)
            }
          })
          .catch(err => {
            vm.deviceuserSpinning = false
            console.log(err);
            this.$message.error(err.message);
          })
    },
    openDevice(record){
      this.user = record;
      this.objectids = []
      this.selectedRowKeys = []
      this.selectedRowDUIds = []
      this.devicePageIndex = 1;
      this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
      this.deviceuserVisible = true;
    },
    // 搜索
    onDeviceSearch(value) {
      console.log(value)
      this.deviceName = value;
      this.devicePageIndex = 1;
      this.getDeviceListData(this.devicePageIndex, this.devicePageSize, this.deviceName)
    },
    // 取消
    deviceCancel() {
      this.deviceuserVisible = false;
      this.objectids = []
      this.selectedRowKeys = []
      this.selectedRowDUIds = []
    },

    /**
     *逻辑区
     */
    // 表格页面跳转
    handleTableChange(pagination) {
      const pager = {...this.pagination};
      pager.current = pagination.current;
      this.pagination = pager;
      this.pageIndex = pager.current - 1
      this.getAdminuserListData(this.pageIndex, this.pageSize, this.adminuserName)
    },
    // 删除
    delAdminuser(record) {
      this.DELvisible = !this.DELvisible;
      this.DELadminuserName = record.adminuserName,
        this.DELadminuserId = record.id
    },
    // 取消删除
    cancel() {
      this.DELvisible = !this.DELvisible;
    },
    // 查看后台用户信息
    lookAdminuserInfo(record) {

      this.getAdminuserInfo(record.id);
      this.adminuserinfoVisible = true;
    },
    // 修改
    AdminuserInfoEdit() {
      this.btnShow = true
    },
    // 取消
    AdminuserInfoCancel() {
      this.adminuserinfoVisible = false;
      this.btnShow = false;
      this.adminuserInfo = {
        id: "",
        name: "",
        nickname: "",
        password: "",
        tel: "",
        company: "",
      }
    },
    // 确定修改
    confirmEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.setEditAdminuser(this.adminuserInfo.id, this.adminuserInfo.name, this.adminuserInfo.nickname, this.adminuserInfo.password, this.adminuserInfo.uid, this.adminuserInfo.company, this.adminuserInfo.tel)
          this.btnShow = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //
    /**
     *逻辑区
     */
    getAdminuserListData(pageIndex, pageSize, adminuserName) {
      this.loading = true;
      AdminuserList(pageIndex, pageSize, adminuserName)
        .then(res => {
          console.log('AdminuserList res', res);
          console.log('AdminuserList res.data', res.data);
          if (res.data.rows.length > 0) {
            // let arr = [];
            this.pagination.total = res.data.total;
            this.adminuserList = res.data.rows;
            this.loading = false;
          } else {
            this.loading = false;
            this.adminuserList = []
            this.$message.error('没有查询到结果，请重试！');
          }
        })
        .catch(err => {
          this.loading = false;
          console.log('+++++++++++++++err', err);
        })
    },
    // 确定删除
    confirm() {
      let that = this
      that.DelSpinning = true
      DelAdminuser(this.DELadminuserId)
        .then(res => {
          console.log(res);
          that.$message.success('删除成功');
          that.getAdminuserListData(this.pageIndex, this.pageSize, this.adminuserName);
          that.DelSpinning = false;
          that.DELvisible = false;
        })
        .catch(err => {
          console.log(err);
          that.DelSpinning = false;
          that.DELvisible = false;
          that.$message.error(err.message);
        })
    },
    // 查询后台用户信息
    getAdminuserInfo(id) {
      this.infoSpinning = true;
      AdminuserInfo(id)
        .then(res => {
          this.infoSpinning = false;
          console.log(res);
          const data = res.data;
          this.adminuserInfo.id = data.id;
          this.adminuserInfo.name = data.name;
          this.adminuserInfo.nickname = data.nickname;
          this.adminuserInfo.tel = data.tel;
          this.adminuserInfo.uid = data.uid;
          this.adminuserInfo.company = data.company;
          this.adminuserInfo.password = '';
        })
        .catch(err => {
          this.infoSpinning = false;
          console.log(err);
        })
    },
    // 修改后台用户信息
    setEditAdminuser(id, name, nickname, password, uid, company, tel) {
      this.DelSpinning = true;
      upDataAdminuserInfo(id, name, nickname, password, uid, company, tel)
        .then(res => {
          this.DelSpinning = false;
          console.log(res);
          this.$message.success('修改成功');
          this.adminuserinfoVisible = false
          this.getAdminuserListData(this.pageIndex, this.pageSize, this.adminuserName);
        })
        .catch(err => {
          this.DelSpinning = false;
          console.log(err);
          this.$message.error('请重试,修改失败');
        })
    },
    //数字格式化
    IntToFloat(fee) {
      return parseFloat(fee).toFixed(2);
    },
    // 冻结用户
    freezeUser(record) {
      const vm = this;
      this.$confirm({
        title: '冻结用户',
        content: `确定要冻结用户 ${record.name} 吗？冻结后该用户将无法登录后台和小程序。`,
        okText: '确定',
        cancelText: '取消',
        onOk() {
          vm.loading = true;
          freezeUser(record.id, '管理员手动冻结')
            .then(res => {
              vm.loading = false;
              vm.$message.success('冻结成功');
              vm.getAdminuserListData(vm.pageIndex, vm.pageSize, vm.adminuserName);
            })
            .catch(err => {
              vm.loading = false;
              console.log(err);
              vm.$message.error(err.message || '冻结失败');
            });
        }
      });
    },
    // 解冻用户
    unfreezeUser(record) {
      const vm = this;
      this.$confirm({
        title: '解冻用户',
        content: `确定要解冻用户 ${record.name} 吗？解冻后该用户可以正常登录。`,
        okText: '确定',
        cancelText: '取消',
        onOk() {
          vm.loading = true;
          unfreezeUser(record.id, '管理员手动解冻')
            .then(res => {
              vm.loading = false;
              vm.$message.success('解冻成功');
              vm.getAdminuserListData(vm.pageIndex, vm.pageSize, vm.adminuserName);
            })
            .catch(err => {
              vm.loading = false;
              console.log(err);
              vm.$message.error(err.message || '解冻失败');
            });
        }
      });
    },
    // 查看冻结历史
    viewFreezeHistory(record) {
      this.currentUser = record;
      this.freezeHistoryVisible = true;
      this.freezeHistoryLoading = true;
      getFreezeRecords(record.id)
        .then(res => {
          this.freezeHistoryLoading = false;
          this.freezeHistoryList = res.data || [];
          if (this.freezeHistoryList.length === 0) {
            this.$message.info('该用户暂无冻结记录');
          }
        })
        .catch(err => {
          this.freezeHistoryLoading = false;
          console.log(err);
          this.$message.error('获取冻结记录失败');
        });
    },
    // 关闭冻结历史弹窗
    closeFreezeHistory() {
      this.freezeHistoryVisible = false;
      this.freezeHistoryList = [];
      this.currentUser = {};
    },
  },
  filters: {
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
}
</script>

<style lang='scss' scoped>
::v-deep .ant-table {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

::v-deep .ant-table-container,
::v-deep .ant-table-content,
::v-deep .ant-table-body,
::v-deep .ant-table-placeholder {
  background: #fff !important;
}

::v-deep .ant-table-thead > tr > th {
  background: #33CCE0 !important;
  color: #fff !important;
  font-weight: 600;
  border-color: #7fddec !important;
}

::v-deep .ant-table-tbody > tr > td {
  background: #fff !important;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background: #e6f9fc !important;
}

::v-deep .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ccf3f8 !important;
}

.action-disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}

::v-deep .ant-table-bordered .ant-table-body > table,
::v-deep .ant-table-bordered .ant-table-fixed-left table,
::v-deep .ant-table-bordered .ant-table-fixed-right table {
  border-color: #7fddec !important;
}

::v-deep .ant-table-bordered .ant-table-thead > tr > th,
::v-deep .ant-table-bordered .ant-table-tbody > tr > td {
  border-color: #b3eaf3 !important;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active {
  border-color: #33CCE0;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active a {
  color: #33CCE0;
}

::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
  color: #33CCE0;
  border-color: #33CCE0;
}

.delAdminuser {
  text-align: center;

  .DelTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }

  .delIcon {
    display: inline-block;
    width: 196px;
    height: 160px;
  }

  .delHint {
    color: #212121;
    font-size: 36px;
    line-height: 90px;
  }

  .btn-wrap {
    text-align: center;

    .confirm {
      color: #fff;
      background-color: #33CCE0;
    }
  }
}

.adminuserInfo-title {
  line-height: 10px;
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
}

.adminuserInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;

  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}

.userInfo-title {
  line-height: 10px;
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
}

.userInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;

  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}

.freeze-history-info {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 4px;

  p {
    margin: 8px 0;
    font-size: 14px;
    color: #333;
  }
}

.freeze-history-btn-wrap {
  text-align: center;
  margin-top: 20px;

  .btn {
    min-width: 100px;
  }
}
</style>
